import { useState, useEffect } from 'react';
import { getRecentLocations, saveRecentLocation, StoredLocation } from '@/utils/locationUtils';

export const useRecentLocations = () => {
  const [recentLocations, setRecentLocations] = useState<StoredLocation[]>([]);

  useEffect(() => {
    setRecentLocations(getRecentLocations());
  }, []);

  const addRecentLocation = (location: string) => {
    saveRecentLocation(location);
    setRecentLocations(getRecentLocations());
  };

  return { recentLocations, addRecentLocation };
};